export const CSS_VAR_GRID_TEMPLATE_COLUMNS = '--grid-template-columns';

export const CSS_VAR_ROW_DRAG_GRID_TEMPLATE_COLUMNS = '--row-drag-grid-template-columns';

export const CSS_CLASS_DROP_LIST_ROW_DRAGGING = 'drop-list-row-dragging';
